import { Component, OnInit, ViewChild } from '@angular/core';
import{ FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from '../../services/common.service';
import { ApiService } from '../../services/api.service';
import { Location } from '@angular/common';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.page.html',
  styleUrls: ['./notification.page.scss'],
})
export class NotificationPage implements OnInit {

  notificationForm:FormGroup;
  submitted = false;
 
  notificationId: string;
  notification: any = {};
  selectedUsers: any =  [];
  showPage: boolean = false;

  Users: any = [];

  config: any = {
    fontNames: ['Arial', 'Arial Black', 'Comic Sans MS', 'Courier New', 'Helvetica', 'Roboto', 'sans-serif;', 'Times New Roman', 'Verdana'],
    height: 300,
    toolbar: [
      ['headline', ['style']],
      ['misc', ['codeview', 'undo', 'redo', 'codeBlock']],
      ['font', ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript', 'clear']],
      ['fontsize', ['fontname', 'fontsize', 'color']],
      ['para', ['style0', 'ul', 'ol', 'paragraph', 'height']],
      ['insert', ['picture','video', 'link']],
      ['table', ['table']]
    ]
  };

  constructor(private router: Router, private route: ActivatedRoute,
    private formBuilder: FormBuilder, private _apiService: ApiService, public _commonService: CommonService, private location: Location) { }
 

  ngOnInit() {
    this.notificationForm = this.formBuilder.group({
      Body: ['', Validators.required],
      Users: [null, Validators.required],
    });
  }

 ionViewDidEnter() {
  let locale = Number((localStorage.locale && localStorage.locale != '') ? localStorage.locale : 1043);
  if(locale == 1043) {
    this.config.lang = 'nl-NL';
  }
  this.notificationId = this.route.snapshot.paramMap.get('id');
   if (this.notificationId == '0') {
    this.notificationId = null;
    this.getUsers();
    }
   else {
   this.getNotificationDetails();
    
    }
   
  }

  async getNotificationDetails() {
  try {
    this._commonService.presentLoading();
    let res = await this._apiService.getNotification(this.notificationId);
    this.notification = res.body;
    this._commonService.log(this.notification, this._commonService.LOG);
    this.notificationForm.patchValue({
          Body: this.notification.Text ,
          SenderUserName:this.notification.Sender.UserName,
    });

    localStorage.setItem('notificationsUnreadCount', this.notification.NotificationsUnreadCount ? this.notification.NotificationsUnreadCount : 0);
    this._commonService.notificationsUnreadCount = this.notification.NotificationsUnreadCount ? this.notification.NotificationsUnreadCount : 0;
    // let source = this._commonService.getSanitizedHtml(this.notification.Subject);
    this._commonService.dismiss();
    this. notificationForm.updateValueAndValidity();
    this.showPage = true;
    } catch (error) {
    this._commonService.dismiss();
    this._commonService.log(error, this._commonService.ERROR);
    }
   }

   async getUsers(){
     try {
      this._commonService.presentLoading();
      let usersData = await this._apiService.getUsers('', '', '', 1, 0, '', 1, 0, 0,false, '', '');
       usersData.body = usersData.body.map( user => {
         let name = user.FirstName + " " + user.LastName;
         user.Name = name;
         return user;
       } )
       this.notification.Users = usersData.body;
       this.notification.Users = [...this.notification.Users.sort(function (a, b) {
            let alc = a.FirstName.toLowerCase(), blc = b.FirstName.toLowerCase();
            return alc > blc ? 1 : alc < blc ? -1 : 0;
          })];
       this.Users = [...usersData.body];
       
       this._commonService.dismiss();
       this.showPage = true;
     } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
     }
  }


 get f() { return this.notificationForm.controls; }

 async  onSubmit() {
  this.submitted = true;
  if (this.notificationForm.invalid) {
    if(this.notificationForm.controls.Users.invalid){
      let invaliduser = document.querySelector('.ng-select');
      if (invaliduser) invaliduser.classList.add("ngselect-invalid");
    }
    this._commonService.scrollToError();
    return;
  }
  this._commonService.presentLoading();
  try {
     let data = {
       Text: this.notificationForm.value.Body,
       Recipients: this.notificationForm.value.Users.join(',')

     }
     this._commonService.log(data, this._commonService.LOG);
      await this._apiService.postNotification(data)
      this._commonService.dismiss();
      this._commonService.showToast(this._commonService.getLocalTranslation('label-notificationSent'));
      this.location.back();
  }
  catch (error) {
    this._commonService.log(error, this._commonService.ERROR);
    this._commonService.dismiss();
  }
}
 
  goBack() {
    this.location.back();
  }

  // itemAdded(event){
  //   this.ngSelectComponent.close();
  //   let invaliduser = document.querySelector('.ng-select');
  //     if (invaliduser) invaliduser.classList.remove("ngselect-invalid");
  //   this.notification.Users = [...this.notification.Users.filter( (user) => {
  //     return user.UserId != event
  //   } )];
  // }

  // itemRemoved(event){
  //   let user = this.Users.find(user => user.UserId == event.value )
  //   if (user) this.notification.Users.push(user);
  //   this.notification.Users = [...this.notification.Users.sort(function (a, b) {
  //     let alc = a.UserName.toLowerCase(), blc = b.UserName.toLowerCase();
  //     return alc > blc ? 1 : alc < blc ? -1 : 0;
  //   })];
  //   if(!(this.notificationForm.value.Users.length > 0)){
  //     let invaliduser = document.querySelector('.ng-select');
  //     if (invaliduser) invaliduser.classList.add("ngselect-invalid");
  //   }else{
  //     let invaliduser = document.querySelector('.ng-select');
  //     if (invaliduser) invaliduser.classList.remove("ngselect-invalid");
  //   }
  // }
  delete() {
    this._commonService.presentAlertConfirm()
      .then(async (res) => {
        try {
          this._commonService.presentLoading();
          await this._apiService.deleteNotifications(this.notificationId);
          this._commonService.dismiss();
          this._commonService.log(res, this._commonService.LOG);
          this.goBack();
        } catch (error) {
          this._commonService.dismiss();
          this._commonService.log(error, this._commonService.ERROR);
        }
      })
      .catch((err) => {
        this._commonService.log(err, this._commonService.LOG);
      })
  }
  
  onActionChange(obj) {

    switch (obj.Action) {
      case "save":
        this.onSubmit();
        break;
      case "delete":
        this.delete();
        break;
      case "backToList":
        this.goBack();
        break;
      case "backToMain":
        this.router.navigate(['maintenance'], { replaceUrl: true })
        break;
      case "back":
        this.goBack();
        break;
    }

  }

 

}
